import {getMonitorLifecycleTexts, useMonitorToggle} from 'entities/monitor';
import {portMonitorAPI} from 'features/port/api/portMonitorAPI';

import {IPortMonitorListItem} from './PortMonitor/IPortMonitor';

export const usePortMonitorToggle = (
    item: Pick<IPortMonitorListItem, 'uuid' | 'status'>,
    onLimit: () => void,
) => {
    const [startPortMonitor] = portMonitorAPI.useStartPortMonitorMutation();
    const [stopPortMonitor] = portMonitorAPI.useStopPortMonitorMutation();
    const isPaused = item.status === 'paused';
    const texts = getMonitorLifecycleTexts();

    return useMonitorToggle({
        isActive: !isPaused,
        isPaused,
        pause: () => stopPortMonitor(item.uuid).unwrap(),
        resume: () => startPortMonitor(item.uuid).unwrap(),
        pausedText: texts.paused,
        resumedText: texts.resumed,
        onLimit,
    });
};

export default usePortMonitorToggle;
